export default "__VITE_ASSET__CADXCfhj__"